import React, { useLayoutEffect, useState } from "react";
import style from "./Screen03.module.css";
import bottle from "../assets/bottle.png";
import naocale from "../assets/naocale.png";
import naocalewon from "../assets/naocalewon.png";
import ringholder from "../assets/ringholder.png";
import ringholderwon from "../assets/ringholderwon.png";
import nista from "../assets/nista.png";
import nistawon from "../assets/nistawon.png";
import start from "../assets/start.png";
import startact from "../assets/startact.png";
import naocare from "../assets/naocare.png";
import naocarewon from "../assets/naocarewon.png";
import ocala from "../assets/ocala.png";
import ocalawon from "../assets/ocalawon.png";
import brez from "../assets/brez.png";
import brezwon from "../assets/brezwon.png";
import stojalo from "../assets/stojalo.png";
import stojalowon from "../assets/stojalowon.png";
import { shuffle } from "../helpers/helpers";

const Screen03 = ({
  phase,
  setPhase,
  language,
  setLanguage,
  award,
  setAward,
}) => {
  const [btn, setBtn] = useState(start);
  const [btnStyle, setBtnStyle] = useState(style.start);
  const [bottleStyle, setBottleStyle] = useState(style.bottle);
  const [glassesStyle, setGlassesStyle] = useState(style.glasses);
  const [ringholderStyle, setRingholderStyle] = useState(style.ringholder);
  const [nistaStyle, setNistaStyle] = useState(style.nista);
  const [leftStyle, setLeftStyle] = useState(style.left);
  const [rightStyle, setRightStyle] = useState(style.right);
  const [downLeftStyle, setDownLeftStyle] = useState(style.downLeft);
  const [downRightStyle, setDownRightStyle] = useState(style.downRight);
  const [glasses, setGlasses] = useState(naocale);
  const [ring, setRing] = useState(ringholder);
  const [nistaImg, setNistaImg] = useState(nista);
  const [awardsAnim, setAwardsAnim] = useState(null);
  const [awards, setAwards] = useState(null);

  const handleBtn = () => {
    setBtnStyle(style.startact);
    setBtn(startact);
  };
  const handleBtnLeave = () => {
    setBtnStyle(style.start);
    setBtn(start);
  };
  const handleBtnClick = (e) => {
    setAwardsAnim(shuffle(awards)[0]);
    document.body.querySelector("#start").style.pointerEvents = "none";
    document.body.querySelector("#start").style.touchAction = "none";
    const timer2 = setTimeout(() => {
      setPhase(3);
    }, 13000);
    return () => clearTimeout(timer2);
  };

  useLayoutEffect(() => {
    if (language === "Croatia" || language === "Bosnia") {
      setGlasses(naocale);
      setRing(ringholder);
      setNistaImg(nista);
    }
    if (language === "Serbia" || language === "Montenegro") {
      setGlasses(naocare);
      setRing(ringholder);
      setNistaImg(nista);
    }
    if (language === "Slovenia") {
      setGlasses(ocala);
      setGlassesStyle(style.ocala);
      setRing(stojalo);
      setRingholderStyle(style.stojalo);
      setNistaImg(brez);
      setNistaStyle(style.brez);
    }
    if (language === "Croatia") {
      setAwards([
        "glasses",
        "glasses",
        "glasses",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
      ]);
    }
    if (language === "Slovenia") {
      setAwards([
        "glasses",
        "glasses",
        "glasses",
        "glasses",
        "glasses",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
      ]);
    }
    if (language === "Serbia") {
      setAwards([
        "glasses",
        "glasses",
        "glasses",
        "glasses",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
      ]);
    }
    if (language === "Bosnia" || language === "Montenegro") {
      setAwards([
        "glasses",
        "glasses",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "ring",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
        "nista",
      ]);
    }
  }, [language]);
  useLayoutEffect(() => {
    if (awardsAnim === "glasses") {
      setBottleStyle(style.bottleGlasses);
      setAward("glasses");
      const timer = setTimeout(() => {
        setLeftStyle(style.leftWon);
        if (language === "Croatia" || language === "Bosnia") {
          setGlasses(naocalewon);
        }
        if (language === "Serbia" || language === "Montenegro") {
          setGlasses(naocarewon);
        }
        if (language === "Slovenia") {
          setGlasses(ocalawon);
        }
      }, 11000);
      return () => clearTimeout(timer);
    }
    if (awardsAnim === "ring") {
      setBottleStyle(style.bottleRing);
      setAward("ring");
      const timer = setTimeout(() => {
        setRightStyle(style.rightWon);
        if (
          language === "Croatia" ||
          language === "Bosnia" ||
          language === "Montenegro" ||
          language === "Serbia"
        ) {
          setRing(ringholderwon);
        }
        if (language === "Slovenia") {
          setRing(stojalowon);
        }
      }, 10000);
      return () => clearTimeout(timer);
    }
    if (awardsAnim === "nista") {
      setBottleStyle(style.bottleNothing);
      setAward("nista");
      const timer = setTimeout(() => {
        setDownLeftStyle(style.downLeftWon);
        setDownRightStyle(style.downRightWon);
        if (
          language === "Croatia" ||
          language === "Bosnia" ||
          language === "Montenegro" ||
          language === "Serbia"
        ) {
          setNistaImg(nistawon);
        }
        if (language === "Slovenia") {
          setNistaImg(brezwon);
        }
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [awardsAnim, language, setAward, setPhase]);
  return (
    <div>
      <div className={style.out}>
        <div className={style.in}>
          <div className={leftStyle}>
            <img src={glasses} alt="glasses" className={glassesStyle} />
          </div>
          <div className={rightStyle}>
            <img src={ring} alt="holder" className={ringholderStyle} />
          </div>
          <div className={downLeftStyle}></div>
          <div className={downRightStyle}></div>
          <div className={style.down}>
            <img src={nistaImg} alt="nothing" className={nistaStyle} />
          </div>
          <div className={style.bottleHolder}>
            <img src={bottle} alt="bottle" className={bottleStyle}/>
          </div>
        </div>
      </div>
      <img
        src={btn}
        id="start"
        alt="start"
        className={btnStyle}
        onPointerDown={handleBtn}
        onPointerLeave={handleBtnLeave}
        onPointerUp={handleBtnClick}
        // style={{
        //   pointerEvents: pointerEvent
        // }}
      />
    </div>
  );
};

export default Screen03;
